export const MERCEDES_XENTRY_SYNC_ACTION = 'xentry-job-sync';
